import { render, staticRenderFns } from "./EbpmsTab.vue?vue&type=template&id=0fc8ff6b&scoped=true"
import script from "./EbpmsTab.vue?vue&type=script&lang=js"
export * from "./EbpmsTab.vue?vue&type=script&lang=js"
import style0 from "./EbpmsTab.vue?vue&type=style&index=0&id=0fc8ff6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8ff6b",
  null
  
)

export default component.exports